// Override Bootstrap Modal to prevent closing on backdrop click
(function() {
  'use strict';

  // Wait for Bootstrap to be loaded
  function waitForBootstrap() {
    // eslint-disable-next-line no-undef
    if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Modal) {
      overrideBootstrapModal();
    } else {
      setTimeout(waitForBootstrap, 100);
    }
  }

  function overrideBootstrapModal() {
    // eslint-disable-next-line no-undef
    const originalModal = window.bootstrap.Modal;
    
    // Override the Modal constructor
    // eslint-disable-next-line no-undef
    window.bootstrap.Modal = function(element, options) {
      // Set backdrop to static by default
      if (options && options.backdrop !== false) {
        options.backdrop = 'static';
      }
      
      const modal = new originalModal(element, options);
      
      // Override the hide method
      const originalHide = modal.hide;
      modal.hide = function() {
        // Check if the hide was triggered by backdrop click
        const currentEvent = window.event || arguments[0];
        if (currentEvent && currentEvent.target && currentEvent.target.classList && currentEvent.target.classList.contains('modal-backdrop')) {
          return; // Prevent hiding
        }
        return originalHide.call(this);
      };
      
      return modal;
    };

    // Override existing modals
    document.addEventListener('DOMContentLoaded', function() {
      const modals = document.querySelectorAll('.modal');
      modals.forEach(modal => {
        try {
          // eslint-disable-next-line no-undef
          const modalInstance = window.bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            const originalHide = modalInstance.hide;
            modalInstance.hide = function() {
              const currentEvent = window.event || arguments[0];
              if (currentEvent && currentEvent.target && currentEvent.target.classList && currentEvent.target.classList.contains('modal-backdrop')) {
                return;
              }
              return originalHide.call(this);
            };
          }
        } catch (error) {
          // Modal instance not found, skip
          console.log('Modal instance not found for:', modal);
        }
      });
    });

    // Watch for new modals
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('modal')) {
            // New modal added, override its behavior
            setTimeout(() => {
              try {
                // eslint-disable-next-line no-undef
                const modalInstance = window.bootstrap.Modal.getInstance(node);
                if (modalInstance) {
                  const originalHide = modalInstance.hide;
                  modalInstance.hide = function() {
                    const currentEvent = window.event || arguments[0];
                    if (currentEvent && currentEvent.target && currentEvent.target.classList && currentEvent.target.classList.contains('modal-backdrop')) {
                      return;
                    }
                    return originalHide.call(this);
                  };
                }
              } catch (error) {
                // Modal instance not found yet, try again later
                setTimeout(() => {
                  try {
                    // eslint-disable-next-line no-undef
                    const modalInstance = window.bootstrap.Modal.getInstance(node);
                    if (modalInstance) {
                      const originalHide = modalInstance.hide;
                      modalInstance.hide = function() {
                        const currentEvent = window.event || arguments[0];
                        if (currentEvent && currentEvent.target && currentEvent.target.classList && currentEvent.target.classList.contains('modal-backdrop')) {
                          return;
                        }
                        return originalHide.call(this);
                      };
                    }
                  } catch (error2) {
                    // Still not found, skip
                  }
                }, 200);
              }
            }, 100);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Start the override process
  waitForBootstrap();

  // Also handle modals that might be created before Bootstrap loads
  document.addEventListener('DOMContentLoaded', function() {
    // Disable backdrop clicks directly
    function disableBackdropClicks() {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.style.pointerEvents = 'none';
        backdrop.style.cursor = 'default';
        
        // Remove click event listeners
        const newBackdrop = backdrop.cloneNode(true);
        backdrop.parentNode.replaceChild(newBackdrop, backdrop);
      });
    }

    // Run immediately
    disableBackdropClicks();

    // Watch for new backdrops
    const backdropObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('modal-backdrop')) {
            node.style.pointerEvents = 'none';
            node.style.cursor = 'default';
          }
        });
      });
    });

    backdropObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})(); 